'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _Errors = require('./Errors');

var _Errors2 = _interopRequireDefault(_Errors);

var _Input = require('../../elements/Input');

var _Input2 = _interopRequireDefault(_Input);

var _Label = require('../../elements/Label');

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var inlineLabels = ['checkbox', 'radio', 'switch'];

var Field = function (_React$Component) {
  _inherits(Field, _React$Component);

  function Field() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Field);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Field.__proto__ || Object.getPrototypeOf(Field)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focus: false
    }, _this.handleFocus = function (e) {
      _this.setState({ focus: true });
      _this.props.onFocus && _this.props.onFocus(e);
    }, _this.handleBlur = function (e) {
      _this.setState({ focus: false });
      _this.props.onBlur && _this.props.onBlur(e);
    }, _this.handleChange = function (value) {
      _this.props.onChange && _this.props.onChange(value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Field, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          label = _props.label,
          optional = _props.optional,
          errors = _props.errors,
          description = _props.description,
          _props$className = _props.className,
          className = _props$className === undefined ? '' : _props$className,
          children = _props.children,
          _props$disabled = _props.disabled,
          disabled = _props$disabled === undefined ? false : _props$disabled,
          placeholder = _props.placeholder,
          type = _props.type,
          value = _props.value,
          props = _objectWithoutProperties(_props, ['name', 'label', 'optional', 'errors', 'description', 'className', 'children', 'disabled', 'placeholder', 'type', 'value']);

      var focus = this.state.focus;

      var hasErrors = errors && errors.length;

      var inlineLabel = inlineLabels.indexOf(type) > -1;
      var input = children || React.createElement(_Input2.default, _extends({
        name: name,
        id: name
      }, props, {
        className: hasErrors ? 'errors' : undefined,
        value: value,
        type: type,
        placeholder: placeholder || label,
        disabled: disabled,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus
      }));
      return React.createElement(
        'div',
        {
          className: 'Field ' + className + ' field-' + name + ' ' + (focus ? 'focus' : '') + ' ' + (hasErrors ? 'errors' : '')
        },
        label && React.createElement(
          _Label2.default,
          { htmlFor: name },
          label,
          optional && React.createElement(
            'span',
            { className: 'optional' },
            '(Optional)'
          )
        ),
        React.createElement(
          'div',
          { className: 'field-content' },
          React.createElement(
            'div',
            { className: 'field' },
            input
          ),
          React.createElement(_Errors2.default, { errors: errors, name: name }),
          description && React.createElement(
            'div',
            { className: 'field-description' },
            description
          )
        )
      );
    }
  }]);

  return Field;
}(React.Component);

exports.default = Field;